import Vue from 'vue'

//公共方法
const api = {
  // 打开链接（支持网址和路由跳转
  openWindow (url, target = '_blank') {
    console.log('url', url)
    if (!url) {
      Vue.prototype.$message({
        showClose: true,
        message: 'url为空，地址打开失败',
        type: 'warning',
        offset: 80
      });
      return
    }
    // 使用正则表达式进行网址验证
    const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    if (urlRegex.test(url)) {
      window.open(url, target);
    } else {
      // 统一在下面添加 '/' hash 模式下需要这样处理
      if (url.startsWith("/")) {
        url = url.slice(1);
      }
      // 不是网址的话，就是路由跳转
      window.open(`#/${url}`, target);

      // window.open(`${url}`, target);
    }
  },
}

export default api



// WEBPACK FOOTER //
// ./src/utils/globalApi.js